import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { PrefsProvider } from "./lib/prefs";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";

function App() {
  return (
    <PrefsProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
    </PrefsProvider>
  );
}

export default App;
